import { Col, Row } from "react-bootstrap";
import { ITableHeader } from "../../oversight-core/interfaces/table-header";
import { ITableRowProps } from "../../oversight-core/interfaces/table-row-props";
import MaterialIcon from "../../oversight-core/ui-elements/material-icon/material-icon";
import SiteErrorLogTableRow from "./site-error-log-table-row/site-error-log-table-row";
import styles from "./site-error-log-table.module.scss";

interface IProps {
  headers: ITableHeader[];
  data: ITableRowProps[];
}

const SitesErrorLogTable = (props: IProps) => {
  const { headers, data } = props;

  return (
    <div
      className={`${styles[`table-grid`]} p-4 rounded-3`}
      style={{ gridTemplateColumns: `repeat(${headers.length}, 1fr)` }}
    >
      {headers.map((header) => (
        <Row
          key={header.id}
          className="row-cols-auto align-items-center px-2 pb-2"
        >
          <Col className="pe-0 text-dark font-weight-400 font-size-12">
            {header.columnName}
          </Col>
          {header.isSort && (
            <Col className="ps-2">
              <MaterialIcon
                icon={header.sort ? `arrow_downward` : `arrow_upward`}
                color="#383941"
                size={13}
                weight={700}
              />
            </Col>
          )}
        </Row>
      ))}
      {data &&
        data.map((item, index) => (
          <SiteErrorLogTableRow key={index} {...item} />
        ))}
    </div>
  );
};

export default SitesErrorLogTable;
